function NXCoupon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
    >
      <g clipPath="url(#clip0_4293_1291)">
        <path
          d="M0.821411 18.5717C0.821411 19.479 1.55572 20.2145 2.46152 20.2145H20.5385C21.4442 20.2145 22.1786 19.479 22.1786 18.5717V15.2301C20.7586 14.8446 19.7141 13.5446 19.7141 12.0002C19.7141 10.4559 20.7586 9.15594 22.1786 8.77044V5.42882C22.1786 4.5215 21.4442 3.78596 20.5385 3.78596H2.46152C1.55572 3.78596 0.821411 4.52149 0.821411 5.42882V8.76321C2.25513 9.13948 3.3129 10.4461 3.3129 12.0002C3.3129 13.5544 2.25513 14.861 0.821411 15.2373V18.5717Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.42651 16.1074L15.6408 7.89311"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.24794 9.53597C8.7016 9.53597 9.06937 9.1682 9.06937 8.71454C9.06937 8.26088 8.7016 7.89311 8.24794 7.89311C7.79428 7.89311 7.42651 8.26088 7.42651 8.71454C7.42651 9.1682 7.79428 9.53597 8.24794 9.53597Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.8194 16.1074C15.2731 16.1074 15.6408 15.7396 15.6408 15.286C15.6408 14.8323 15.2731 14.4645 14.8194 14.4645C14.3658 14.4645 13.998 14.8323 13.998 15.286C13.998 15.7396 14.3658 16.1074 14.8194 16.1074Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4293_1291">
          <rect
            width="23"
            height="23"
            fill="white"
            transform="translate(0 0.500244)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default NXCoupon;
